import { RouterLayoutBasic } from "@opendash/core";
import { RouterLayoutProps } from "@opendash/router";
import { observer } from "mobx-react-lite";
import React from "react";
import { AgencyContextProvider } from "../contexts/AgencyContextProvider";
import { AgencySelector } from "../contexts/AgencySelector";

export const Layout = observer(function Layout(props: RouterLayoutProps) {
  return (
    <AgencyContextProvider>
      <RouterLayoutBasic {...props} padding={true} actions={<AgencySelector />}>
        {props.children}
      </RouterLayoutBasic>
    </AgencyContextProvider>
  );
});
